import {http} from "@/assets/utils/api";

/**
 * 首页顶部数据统计
 */
export const getHomeData = () => http.get('/yymCourse/indexHomeCount',{custom:{isAuth:false}});